import * as React from 'react';
import { Fab } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { IEditAction } from './interfaces';

export const EditAction: React.FC<IEditAction> = ({ onClick }): JSX.Element => {
  return (
    <Fab color="primary" onClick={onClick}>
      <EditIcon />
    </Fab>
  );
};
